import React, { useState } from 'react';
import axios from '../../axios';
import QuestionList from './question_list';

const QuestionCreateForm = () => {
  const [title, setTitle] = useState('');
  const [questions, setQuestions] = useState([]);

  const addQuestion = () => {
    setQuestions((prev) => [
      ...prev,
      {
        wording: '',
        choiceType: 1,
        isRequired: true,
        options: [],
      },
    ]);
  };

  const saveQuestionGroup = async () => {
    if (title === '') {
      alert('タイトルを入力してください');
      return;
    }
    if (questions.length === 0) {
      alert('設問を追加してください');
      return;
    }
    if (questions.some((q) => q.wording === '')) {
      alert('設問を入力してください');
      return;
    }
    if (questions.some((q) => q.choiceType !== 3 && q.options.length === 0)) {
      alert('選択肢を追加してください');
      return;
    }

    const payload = {
      title,
      questions: questions.map((q) => ({
        wording: q.wording,
        choiceType: q.choiceType,
        isRequired: q.isRequired,
        options: q.options,
      })),
    };

    try {
      const res = await axios.post('/api/admin/questions/create', payload);
      if (res.status === 200) {
        alert('アンケートを作成しました');
        window.location.href = '/admin/questions';
      } else {
        alert('アンケートの作成に失敗しました');
      }
    } catch (error) {
      console.error('Error:', error.response.data);
    }
  };

  return (
    <div>
      <div>
        <label>タイトル</label>
        <input
          type="text"
          className="form-control"
          placeholder="アンケートタイトルを入力"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <QuestionList questions={questions} setQuestions={setQuestions} />

      <div className="mt-3">
        <button className="btn btn-info" onClick={addQuestion}>
          + 設問を追加
        </button>
        <button className="btn btn-info ml-4" onClick={saveQuestionGroup}>
          保存
        </button>
      </div>
    </div>
  );
};

export default QuestionCreateForm;
